// src/pages/transport-requests/TransportArrivalRequestPage.tsx
import React from "react";
import { Container, Paper, Stack, Title, Text } from "@mantine/core";
import { MantineProvider } from "@mantine/core";
import TransportArrivalRequestStepper from "./TransportArrivalRequestStepper";
import { IconPlaneArrival, IconPlaneDeparture, IconArrowsLeftRight, IconAlertCircle } from "@tabler/icons-react";

export default function TransportArrivalRequestPage() {
    return (
        <Container size="md" py="xl">
            <Paper withBorder p="lg" radius="md">
                <Stack gap="xs">
                    <Title order={3}><IconPlaneArrival size={25} /> Transport Arrival request</Title>
                    <Text c="dimmed">
                        Fill in your arrival and contact information - and we will register your transport.
                    </Text>
                </Stack>
            </Paper>

            <Paper withBorder p="lg" radius="md" mt="md">
                <MantineProvider
                    theme={{
                        primaryColor: "brand",
                        colors: {
                            brand: [
                                "#ffe5e5",
                                "#ffcaca",
                                "#ff9a9a",
                                "#ff7a7a",
                                "#ff6868",
                                "#ff5e5e",
                                "#f24848",
                                "#e53a3a",
                                "#d92d2d",
                                "#cc2222",
                            ],
                        },
                    }}
                >
                    <TransportArrivalRequestStepper />
                </MantineProvider>
            </Paper>
        </Container>
    );
}